import type { LaserficheInternalConfiguration } from "@repo/types";
import { Button } from "@repo/ui/components/Base/Button";
import { useFutureCallback } from "@repo/ui/components/Base/hooks/useFutureCallback";
import { Input } from "@repo/ui/components/Base/Input";
import { useState } from "react";
import { SaveAllContext } from "./saveAllContext";
import { useBlockUnload } from "@repo/ui/components/Base/hooks/useBlockUnload";

export interface LaserficheInternalConfigProps {
  initialInternalConfig?: LaserficheInternalConfiguration | null;
  onSave?: (
    internalConfig: LaserficheInternalConfiguration
  ) => void | Promise<void>;
}

export const LaserficheInternalConfig = ({
  initialInternalConfig,
  onSave,
}: LaserficheInternalConfigProps) => {
  const [loading, setLoading] = useState(false);
  const [errorEmail, setErrorEmail] = useState(
    initialInternalConfig?.errorEmail ?? ""
  );

  const [saved, setSaved] = useState(true);

  useBlockUnload(saved);

  const handleSave = useFutureCallback(async () => {
    setLoading(true);
    await onSave?.({
      errorEmail: errorEmail || undefined,
    });
    setSaved(true);
    setLoading(false);
  });

  SaveAllContext.useAsChild({
    order: 1,
    save: handleSave,
  });

  return (
    <div className="flex flex-col gap-5">
      <p className="text-lg font-bold">Admin Settings:</p>

      <Input
        disabled={loading}
        label="Error Notification Email"
        id="erroremail"
        value={errorEmail}
        onChange={(evt) => {
          setErrorEmail(evt.target.value);
          setSaved(false);
        }}
      />
      <p>
        Enter an email that will receive notifications about errors during data
        upload to Laserfiche.
      </p>

      <div className="flex flex-row justify-between">
        <div />
        <Button disabled={loading} onClick={handleSave}>
          Save Admin Settings
        </Button>
      </div>
    </div>
  );
};
